import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { authClient } from './auth/authClient';
import './index.css';

// Initialize authentication — extracts tokens from URL fragment,
// validates stored tokens, or redirects to login.galigali.in.
// In development (CRA dev server) there is no login.galigali.in session and
// the local API runs MOCK_AUTH, so requireAuth is off — same convention as
// AuthGate's DEV_BYPASS; production behavior is unchanged.
authClient.init({ requireAuth: process.env.NODE_ENV !== 'development' });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
